import * as React from "react";

import ReactTable from "react-table";
import { Column } from "react-table";
import "react-table/react-table.css";

import { Container, Button, InputGroup, InputGroupAddon, Input } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

import "./messages.css";
import i18n from "../i18n";

import MessagesEdit from "./messages-edit";
import { getAsync, postAsync } from "utils/net";
import { checkRole } from "security/security";

export interface MessagesTableProps { }
export interface MessagesTableState {
  items: any[];
  loading: boolean;
  selectedItem: any;
  showEdit: boolean;
  showDelete: boolean;
  isNew: boolean;
  quickfind: string;
}

export class MessagesTable extends React.Component<
  MessagesTableProps,
  MessagesTableState
  > {
  private filterMethod = (filter: any, row: any) =>
    new RegExp(filter.value, "i").test(String(row[filter.id]));

  private columns: Column[] = [
    {
      Header: i18n.Messages.Table.Keyword,
      accessor: "rowKey",
      width: 250
    },
    {
      Header: i18n.Messages.Table.Message,
      accessor: "message"
    },
    {
      Header: i18n.Messages.Table.Language,
      accessor: "lang"
    },
    {
      Header: "",
      filterable: false,
      show: checkRole("Ssml.Change"),
      maxWidth: 50,
      Cell: row => (
        <Button
          size="sm"
          color="primary"
          onClick={() => this.onEdit(row.original)}
        >
          <FontAwesomeIcon icon={faPencilAlt} />
        </Button>
      )
    },
    {
      Header: "",
      filterable: false,
      show: checkRole("Ssml.Change"),
      maxWidth: 50,
      Cell: row => (
        <Button
          size="sm"
          color="danger"
          onClick={() => this.onDelete(row.original)}
        >
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      )
    }
  ];
  constructor(props: MessagesTableProps) {
    super(props);
    this.state = {
      selectedItem: null,
      loading: false,
      showDelete: false,
      showEdit: false,
      isNew: false,
      items: [],
      quickfind: "",
    };
  }
  componentWillMount() {
    this.loadMessages();
  }

  render() {
    return (
      <Container className="messages-page page">
        <h1 className="page-header">{i18n.Messages.Title}</h1>
        <p>
          {checkRole("Ssml.Change") &&
            (<Button color="primary" size="sm" onClick={() => this.onNew()}>
              <FontAwesomeIcon icon={faPlus} />
              &nbsp;
            {i18n.Messages.Form.NewButton}
            </Button>)}
        </p>
        <p>
          <InputGroup>
            <InputGroupAddon addonType="prepend">🔍</InputGroupAddon>
            <Input placeholder="quick find" onChange={e => this.onQuickFind(e)} />
          </InputGroup>
        </p>
        <ReactTable
          noDataText={this.state.loading ? "Loading" : "No items found"}
          data={this.list}
          filterable={true}
          columns={this.columns}
          defaultFilterMethod={this.filterMethod}
          defaultPageSize={10}
          className="-striped -highlight"
        />
        <MessagesEdit
          item={this.state.selectedItem}
          isOpen={this.state.showEdit}
          isNew={this.state.isNew}
          onCancel={() => this.onCancelEdit()}
          onSave={model => this.onSave(model)}
        />
      </Container>
    );
  }

  private async loadMessages() {
    this.setState({ loading: true });
    const reply = await getAsync("/api/messages");
    const payload = await reply.json();
    this.setState({
      items: payload,
      loading: false,
    });
  }

  private onEdit(item: any) {
    this.setState({
      selectedItem: item,
      showEdit: true
    });
  }
  private onCancelEdit() {
    this.setState({
      showEdit: false
    });
  }
  private async onDelete(item: any) {
    if (!confirm(i18n.Global.Delete.Confirm)) {
      return;
    }
    await postAsync("/api/messages", item, "DELETE");
    this.setState({
      showEdit: false,
      isNew: false,
      selectedItem: null
    });
    this.loadMessages();
  }
  private async onSave(model: any) {
    await postAsync("/api/messages", model);
    this.setState({
      showEdit: false,
      isNew: false,
      selectedItem: null
    });
    this.loadMessages();
  }
  private onNew() {
    this.setState({
      showEdit: true,
      isNew: true,
      selectedItem: {
        partitionKey: "MESSAGE",
        rowKey: "",
        message: "",
        lang: "",
      }
    });
  }
  private onQuickFind(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      quickfind: e.target.value,
    })
  }
  private get list() {
    return this.state.items
      .filter(this.state.quickfind
        ? item => this.columns.some(col => this.filterMethod({ id: col.accessor, value: this.state.quickfind }, item))
        : item => true)
  }
}



// WEBPACK FOOTER //
// ./src/messages/messages-list.tsx